import Prismic from '@prismicio/client';
import Vue from 'vue';
const accessToken = process.env.VUE_APP_ACCESS_TOKEN_DREAMHUB_PRISMIC_VUE;
const apiEndpoint = 'https://knn-dreamhub.cdn.prismic.io/api/v2';
const prismicKnnDream = Prismic.client(apiEndpoint, { accessToken });
Vue.prototype.$prismicKnnDream = prismicKnnDream;
